import {
    Dispatch,
    PropsWithChildren,
    SetStateAction,
    createContext,
    useContext,
    useState
} from "react"

export interface PlacementIncompleteContextState {
    placementIncomplete: boolean
    setPlacementIncomplete: Dispatch<SetStateAction<boolean>>
}

export const PlacementIncompleteContext = createContext<
    PlacementIncompleteContextState | undefined
>(undefined)

export const usePlacementIncompleteCtx = () => {
    const ctx = useContext(PlacementIncompleteContext)
    if (!ctx) {
        throw new Error(
            "usePlacementIncompleteCtx must be used within a PlacementIncompleteProvider"
        )
    }

    return ctx
}

// 報告フロー(ready-for-troubles → troubles → finish)をまたいで
// 「設置は未完了」のチェック状態を共有するためのProvider
export const PlacementIncompleteProvider = ({
    children
}: PropsWithChildren) => {
    const [placementIncomplete, setPlacementIncomplete] = useState(false)

    return (
        <PlacementIncompleteContext.Provider
            value={{ placementIncomplete, setPlacementIncomplete }}
        >
            {children}
        </PlacementIncompleteContext.Provider>
    )
}
